export enum RoutesFinalDataEnumFull {
  CONFIRMATION = 'confirmacion-full' as any,
  ULTIMATE = 'confirmacion-fim-full' as any
}
